export default __webpack_public_path__ + "static/benefitImg-4ad7d28fd089aff67339e72878e764e7.png";